module.exports = __webpack_public_path__ + "static/media/show-certificate-btn.bc61da03.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/medals/show-certificate-btn.png
// module id = 551
// module chunks = 6